import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getOptionsApplicationType } from '../../app/store/actions/applicationType';
import { createAutomationProducts, getOptionsAutomationProduct, updateAutomationProducts } from '../../app/store/actions/automationProducts';
import { getOptionsPower } from '../../app/store/actions/power';
import { getOptionsVoltage } from '../../app/store/actions/voltage';
import FIELDS from '../../data/fields';

class AutomationProductsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      toEdit: false,
      isLoading: false,
      listProduct: [],
      product: {
        soneparId: '',
        code: '',
      },
      products: '',
      listApplicationType: [],
      applicationType: '',
      applicationTypeId: '',
      listVoltage: [],
      voltage: '',
      voltageId: '',
      listPower: [],
      power: '',
      powerId: '',
      messageError: '',
      messageSuccess: '',
    };
  }

  componentDidMount = async () => {
    if (this.props.back.location.selected) {
      await this.setSelected(this.props.back.location.selected);
    }

    const products = await this.props.getOptionsAutomationProduct(10, '');
    await this.setState({      
      listProduct: [...products],
    });
    const applications = await this.props.getOptionsApplicationType('');    
    this.setState({
      listApplicationType: [...applications],
    });
    const voltages = await this.props.getOptionsVoltage('');
    this.setState({
      listVoltage: [...voltages],
    });
    const powers = await this.props.getOptionsPower('');
    this.setState({
      listPower: [...powers],
    });
  }

  setSelected = async (selected) => {
    this.setState({
      toEdit: true,
      id: selected.id,
      products: `${selected.product.code} ${selected.product.description}`,
      product: selected.product,
      applicationType: selected.applicationType.description,
      applicationTypeId: selected.applicationType.id,
      voltage: selected.voltage.voltageRange,
      voltageId: selected.voltage.id,
      power: selected.power.power,
      powerId: selected.power.id,
    });
  }

  goBack = () => {
    this.props.back.goBack();
  };

  setOnChangeProduct = async (value) => {
    const result = await this.props.getOptionsAutomationProduct(10, value);
    await this.setState({
      products: value,
      listProduct: [...result],
    });
  };

  setOnChangeApplicationType = async (value) => {
    const result = await this.props.getOptionsApplicationType(value);
    this.setState({
      applicationType: value,
      listApplicationType: [...result],
    });
  };

  setOnChangeVoltage = async (value) => {
    const result = await this.props.getOptionsVoltage(value);
    this.setState({
      voltage: value,
      listVoltage: [...result],
    });
  };

  setOnChangePower = async (value) => {
    const result = await this.props.getOptionsPower(value);
    this.setState({
      power: value,
      listPower: [...result],
    });
  };

  setSelectedFieldId = (field, value, selected) => {
    if (field === 'product') {
      this.setState({
        products: value,
        product: { soneparId: selected.soneparId, code: selected.code },
      });
    }
    else if (field === 'applicationType') {
      this.setState({
        applicationType: value,
        applicationTypeId: selected.id,
      });
    } else if (field === 'voltage') {
      this.setState({
        voltage: value,
        voltageId: selected.id,
      });
    } else if (field === 'power' && !selected.father) {
      this.setState({
        power: value,
        powerId: selected.id,
      });
    }
  };

  createAutomationProducts = async () => {
    this.setState({ isLoading: true });
    const {
      product,
      applicationTypeId,
      voltageId,
      powerId,
    } = this.state;

    if (!product.soneparId || !applicationTypeId || !voltageId || !powerId) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
    }else {
      try {
        await this.props.createAutomationProducts({
          productId: product.soneparId,
          applicationTypeId,
          voltageId,
          powerId,
        });  
        await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
        await this.goBack();
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;
        this.setState({ messageSuccess: '' });
        if (error && error.message) {
          const messageError = (error.code && error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;
  
          this.setState({ messageError });
        } else {
          this.setState({ messageError: I18n.t('errorOcurred') });
        }
      }
    }
    this.setState({ isLoading: false });
  }

  updateAutomationProducts = async () => {
    this.setState({ isLoading: true });
    const {
      id,
      product,
      applicationTypeId,
      voltageId,
      powerId,
    } = this.state;

    if (!product.soneparId || !applicationTypeId || !voltageId || !powerId) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
    }else{
      try {
        await this.props.updateAutomationProducts({
          id,
          productId: product.soneparId,
          applicationTypeId,
          voltageId,
          powerId,
        });
  
        await this.setState({ messageSuccess: I18n.t('changeMade') });
        await this.goBack();
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;
        this.setState({ messageSuccess: '' });
  
        if (error && error.message) {
          const messageError = (error.code && error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;
  
          this.setState({ messageError });
        } else {
          this.setState({ messageError: I18n.t('errorOcurred') });
        }
      }
    }
    this.setState({ isLoading: false });
  }

  render() {
    const {
      toEdit, isLoading, listProduct, products, listApplicationType,
      applicationType, listVoltage, voltage, listPower, power,
      messageSuccess, messageError,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {`${(toEdit) ? I18n.t('editar') : I18n.t('new')} ${I18n.t('product')}`}
        </h2>
        <form>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('productCode')}
            </p>
            <Autocomplete
              getItemValue={item => (`${item.code} ${item.description || item.tacTagId.descriptionLarge}`)}
              items={listProduct || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.code} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {`${item.code} ${item.description} ${item.product.narrativa}`}
                </div>
              )}
              value={products}
              onChange={e => this.setOnChangeProduct(e.target.value)}
              onSelect={(value, selected) => this.setSelectedFieldId('product', value, selected)}
            />
          </div>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('applicationType')}
            </p>
            <Autocomplete
              getItemValue={item => (item.description)}
              items={listApplicationType || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.description} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.description}
                </div>
              )}
              value={applicationType}
              onChange={e => this.setOnChangeApplicationType(e.target.value)}
              onSelect={(value, selected) => this.setSelectedFieldId('applicationType', value, selected)}
            />
          </div>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('voltage')}
            </p>
            <Autocomplete
              getItemValue={item => (item.voltageRange)}
              items={listVoltage || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.voltageRange} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.voltageRange}
                </div>
              )}
              value={voltage}
              onChange={e => this.setOnChangeVoltage(e.target.value)}
              onSelect={(value, selected) => this.setSelectedFieldId('voltage', value, selected)}
            />
          </div>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('power')}
            </p>
            <Autocomplete
              getItemValue={item => (item.father ?  item.powerRange : item.power)}
              items={listPower || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div 
                  key={item.father ?  item.powerRange : item.power} 
                  style={{ background: (isHighlighted && !item.father) ? 'lightgray' : 'white' }}
                  disabled={item.father || false}
                >
                  {item.father ?  item.powerRange : `---- ${item.power}`}
                </div>
              )}
              value={power}
              onChange={e => this.setOnChangePower(e.target.value)}
              onSelect={(value, selected) => this.setSelectedFieldId('power', value, selected)}
            />
          </div>

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageError && <p className="color-red margin-top-10">{messageError}</p>}

          <div className="row margin-left-0 margin-top-20">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => ((!toEdit) ? this.createAutomationProducts() : this.updateAutomationProducts())}
              disabled={isLoading}
            >
              {(!toEdit) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getOptionsAutomationProduct: (limit, search) => dispatch(getOptionsAutomationProduct(limit, search)),
  getOptionsApplicationType: (search) => dispatch(getOptionsApplicationType(search)),
  getOptionsVoltage: (search) => dispatch(getOptionsVoltage(search)),
  getOptionsPower: (search) => dispatch(getOptionsPower(search)),
  createAutomationProducts: newAutomationProducts => dispatch(createAutomationProducts(newAutomationProducts)),
  updateAutomationProducts: updAutomationProducts => dispatch(updateAutomationProducts(updAutomationProducts)),
});

const mapStateToProps = state => ({});


export default connect(mapStateToProps, mapDispatchToProps)(AutomationProductsForm);
